import { Select } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledSelector = styled(Select)(({ theme }) => ({
  '& .MuiSelect-select': {
    borderRadius: 4,
    position: 'relative',
    border: '1px solid',
    borderColor: theme.palette.divider,
    backgroundColor: 'white',
    fontSize: 16,
    padding: '10px 12px',
    transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
    fontFamily: theme.typography.body2.fontFamily,
    '&:hover': {
      borderColor: theme.palette.secondary.main,
    },
  },
  '&.Mui-focused .MuiSelect-select': {
    border: '1px solid #ffffff',
    outline: '1px solid #0894cf',
    boxShadow: '0 0 0 1px #98e0ff, 0 0 0 2px #98e0ff',
  },
}))

export default StyledSelector
